import { useState } from 'react';

import { Button } from '@/components/button';
import FormModal from '@/components/Modals/FormModal';
import { IDebtor } from '@/pages/main/types';

const RetSkyldnerCell = ({ id, debtor }: { id: number; debtor: IDebtor }) => {
  const [showFormModal, setShowFormModal] = useState(false);

  const handleOpen = () => {
    setShowFormModal(true);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        className={
          'bg-[rgba(195,32,37,1)] hover:bg-[#6D0609] transition-[200ms] w-full max-w-[149px]'
        }>
        Ret skyldner
      </Button>

      <FormModal
        isOpen={showFormModal}
        setIsOpen={setShowFormModal}
        id={id}
        debtor={debtor}
      />
    </>
  );
};

export default RetSkyldnerCell;
